// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__1BRKu","range":"MonthRangeSwitch_range__1NRLx","disabled":"MonthRangeSwitch_disabled__2Vffb"};